module.exports = __webpack_public_path__ + "static/media/5.95bf392b.jpg";